/**
 * @generated SignedSource<<e783800048692a82b61e637adf1a9a7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SetADOProjectSettingsInput = {
  projectId?: string | null;
  vstsProject?: string | null;
  vstsArea?: string | null;
  vstsAccount?: string | null;
  vstsSyncBugs?: boolean | null;
  vstsUseEpics?: boolean | null;
  vstsTwoWaySync?: boolean | null;
  vstsUseNewSubtasks?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type SetADOProjectSettingsMutation$variables = {
  input: SetADOProjectSettingsInput;
};
export type SetADOProjectSettingsMutation$data = {
  readonly setADOProjectSettings: {
    readonly project: {
      readonly vstsProject: string | null;
      readonly vstsAccount: string | null;
      readonly vstsArea: string | null;
      readonly vstsSyncBugs: boolean | null;
      readonly vstsUseEpics: boolean | null;
      readonly vstsTwoWaySync: boolean | null;
      readonly vstsUseNewSubtasks: boolean | null;
    } | null;
  } | null;
};
export type SetADOProjectSettingsMutation = {
  variables: SetADOProjectSettingsMutation$variables;
  response: SetADOProjectSettingsMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsProject",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsAccount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsArea",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsSyncBugs",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsUseEpics",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsTwoWaySync",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vstsUseNewSubtasks",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetADOProjectSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetADOProjectSettingsPayload",
        "kind": "LinkedField",
        "name": "setADOProjectSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetADOProjectSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetADOProjectSettingsPayload",
        "kind": "LinkedField",
        "name": "setADOProjectSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0159c8cc6a4916bb800c045b41ef525b",
    "id": null,
    "metadata": {},
    "name": "SetADOProjectSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation SetADOProjectSettingsMutation(\n  $input: SetADOProjectSettingsInput!\n) {\n  setADOProjectSettings(input: $input) {\n    project {\n      vstsProject\n      vstsAccount\n      vstsArea\n      vstsSyncBugs\n      vstsUseEpics\n      vstsTwoWaySync\n      vstsUseNewSubtasks\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "23bd3eaaca5d5d20f1c957619bf9dff4";

export default node;
